import { render, staticRenderFns } from "./UploadResourcesModal.vue?vue&type=template&id=77a2d84b"
import script from "./UploadResourcesModal.vue?vue&type=script&lang=js"
export * from "./UploadResourcesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports